import {useState, useEffect} from 'react'
import axios from "axios"
import { Link } from 'react-router-dom'
import Navbar from './Navbar'



const Registration = () => {
    const [registrationData, setRegistrationData] = useState({
        name: '',
        phone: '',
        email: '',
        password: '',
        termsAndConditions: false,
    })
    const [message, setMessage] = useState(null)

    const handleInputChange = (e) => {
        const { name, type, checked, value } = e.target;
    
        setRegistrationData((prevData) => ({
            ...prevData,
            [name]: type === "checkbox" ? checked : value, // Checkboxy používají `checked`
        }));
    };
    const handleSubmitReservation = async (e) => {
        e.preventDefault()
       
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/users/register`, registrationData)
            setMessage(response?.data.message || "Registrace proběhla úspěšně")
        } catch (error) {
            setMessage('Chyba při registraci:', error.response?.data || error.message)
        }

    }

      useEffect(() => {
        const scrollToTop = () => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        scrollToTop()
      }, [])

      const handleUserRegisteButtonClick = () => {
        window.gtag('event', 'click', {
          event_category: 'Button',
          event_action: 'Click',
          event_label: 'Registrace uzivatele',
        });
      };


  return <div>
        {/* Navbar */}
        <Navbar />
    <div className="login-container">
    <h2 className="login-title">Registrace uživatele</h2>
    <form onSubmit={handleSubmitReservation} className="login-form">
  <input
      type="text"
      placeholder="Jméno a příjmení"
      name="name"
      value={registrationData.name}
      onChange={handleInputChange}
      required
      className="login-input"
  />
  <input
      type="phone"
      placeholder="Telefon"
      name="phone"
      value={registrationData.phone}
      onChange={handleInputChange}
      required
      className="login-input"
  />
  <input
      type="email"
      placeholder="Email"
      name="email"
      value={registrationData.email}
      onChange={handleInputChange}
      required
      className="login-input"
  />
  <input
      type="password"
      placeholder="Heslo"
      name="password"
      value={registrationData.password}
      onChange={handleInputChange}
      required
      className="login-input"
  />
  <div className='gdpr'>
    <p >Souhlasím s podmínky používání</p>
  <input 
    type='checkbox'
    name='termsAndConditions'
    value={registrationData.termsAndConditions}
    onChange={handleInputChange}
    required
  />
  </div>
  <button type="submit" className="login-button" onClick={handleUserRegisteButtonClick}>Registrovat se</button>
</form>
    <div className="login-links">
        <Link to="/termsAndConditions" className="login-link">Podmínky používání a cookies</Link>
        <Link to="/termsAndConditions" className="login-link">Zásady ochrany osobních údajů</Link>

    </div>
{message && <p className="message">{message}</p>}
</div>

</div>
}

export default Registration